import { Button } from "antd"
import { InventoryItem } from "../../../api/inventory/InventoryItem";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";

const inventoryTableColumns: ColumnsType<InventoryItem> = [
  {
    title: "ICCID",
    dataIndex: "Iccid",
    sorter: (a, b) => a.Iccid.localeCompare(b.Iccid),
  },
  {
    title: "Confirmation Code",
    dataIndex: "ConfirmationCode",
    sorter: (a, b) => (a.ConfirmationCode ?? "").localeCompare(b.ConfirmationCode ?? ""),

  },
  {
    title: "Provider SKU",
    dataIndex: "VendorSku",
    sorter: (a, b) => a.VendorSku.localeCompare(b.VendorSku),
  },
  {
    title: "Expiry Date",
    dataIndex: "ExpiryDate",
    sorter: (a, b) => a.ExpiryDate.localeCompare(b.ExpiryDate),
  },
  {
    title: "QR",
    dataIndex: "QrImageUrl",
    render: (v?: string) => {
      if (v != null) {
        return (
          <Button
            href={v}
            type="primary"
          >
            Download
          </Button>
        );
      }
      return "Unavailable"
    }
  },
  {
    title: "Status",
    dataIndex: "Status",
    sorter: (a, b) => (a.Status ?? "Available").toString().localeCompare((b.Status ?? "Available").toString()),
    render: (v?: string, rec?) => {
      if (v === "REDEEMED") {
        if (rec?.sb_RejectedOrderId || rec?.sb_RejectedSimIdx) {
          return "Rejected (Slowboat)";
        }
        if (rec?.sb_ProviderFulfilledAt) {
          return "Redeemed (Slowboat)";
        }
        if (rec?.sb_ProviderSubmittedAt) {
          return "Submitted (Slowboat)";
        }
        if (rec?.sb_AssignedOrderId || rec?.sb_AssignedSimIdx) {
          return "Assigned (Slowboat)";
        }
        return "Sent to Customer";
      }
      if (v) {
        return v;
      }
      if (rec?.ReservedOrderId || rec?.ReservedSimIdx) {
        return "Reserved";
      }
      if (rec?.AssignedDistributorId) {
        return `Reserved for distributor ${rec.AssignedDistributorId}`;
      }
      return "Available"
    }
  },
  {
    title: "View Order",
    key: "viewOrder",
    render: (_, rec) => {
      if (!rec.RedemptionOrderId || !rec.RedemptionSimIdx) {
        return <Button disabled>Unavailable</Button>
      }
      return (
        <Button
          href={`/redemption?reference=${rec.RedemptionOrderId},${rec.RedemptionSimIdx}`}
          type="primary"
        >
          View Order
        </Button>
      )
    }
  },
  {
    title: "Details",
    key: "Details",
    render: (_, rec) => {
      return (
        <Button
          href={"/inventory?iccid=" + rec.Iccid}
          type="dashed"
        >
          Details
        </Button>
      )
    }
  },
]

const withKey = inventoryTableColumns.map(x => ({
  ...x,
  key: x.dataIndex ?? x.title
}))

export default withKey;
